module.exports = __webpack_public_path__ + "img/share.29f47f43.svg";